import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { clinicQKeys } from "@hooks/queries/clinic/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useDeleteClinicLaboratoryService = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (laboratoryServiceId: string) => {
      return api.delete(`clinic/lab-services/${laboratoryServiceId}`);
    },
    onSuccess: () => {
      showSuccessNotification({
        title: "success",
        message: "delete-laboratory-service-success",
      });
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.laboratoryServices(),
      });
    },

    onError: (res: any) => {
      console.error("[From Delete Clinic Laboratory Service]", res);
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.laboratoryServices(),
      });

      handleErrors(res, "mutation");
    },
  });
};
